import React from 'react'
import Helmet from 'react-helmet'
import config from '../utils/siteConfig'
import '../templates/base.scss'
import Layout from '../components/Layout/Layout'
import SEO from '../components/SEO'
import DevSecOpsContent from '../components/DevSecOps/DevSecOpsContent/DevSecOpsContent'
import DevSecOpsHero from '../components/DevSecOps/DevSecOpsHero/DevSecOpsHero'

const DevSecOps = ({ data }) => {
  const postNode = {
    title: `DevSecOps - ${config.siteTitle}`,
  }

  return (
    <Layout>
      <SEO postNode={postNode} pagePath="devsecops" customTitle />
      <Helmet>
        <title>{`DevSecOps - ${config.siteTitle}`}</title>
      </Helmet>
      <DevSecOpsHero />
      <DevSecOpsContent />
    </Layout>
  )
}

export default DevSecOps
